import React, {useState} from 'react';
import {Handle, NodeProps, Position} from 'reactflow';
import {useSmartTriggerConfiguration} from "../../../../context/smartTriggerConfigurationProvider";
import {SmartTriggerProcessorData} from '../../../../types';
import "../css/smartTriggerProcessors.css"
import {ProcessorHeader} from "../fragments/processorHeader";
import {ProcessorCard} from "../fragments/processorCard";
import {ProcessorCardBody} from "../fragments/processorCardBody";
import {SmartTriggerProcessorInputsBox} from "../../inputs/smartTriggerProcessorInputsBox";
import {Button} from "@mantine/core";
import {Edit, TrashX} from "tabler-icons-react";
import {SmartTriggerProcessorConfigurationModal} from "../../../processorConfiguration/smartTriggerProcessorConfigurationModal";


export default function MainProcessorNodeComponent(props: NodeProps) {

    const data: SmartTriggerProcessorData = props.data;
    const smartTriggerConfiguration = useSmartTriggerConfiguration();

    const [editProcessorOpened, setEditProcessorOpened] = useState(false);

    const removeNode = (event: React.MouseEvent) => {
        event.preventDefault()
        smartTriggerConfiguration.removeProcessor(props.id)
    }


    return (
        <>
            <ProcessorCard isSelected={props.selected}>
                <ProcessorHeader title={data.name}>
                    <Button radius={"sm"}
                            color={"red"}
                            rightIcon={<TrashX/>}
                            size={"xs"}
                            variant="subtle"
                            onClick={removeNode}
                    />
                </ProcessorHeader>
                <hr className={"smart-trigger-divider"}/>
                <ProcessorCardBody body={data.description}/>
                <SmartTriggerProcessorInputsBox nodeId={props.id}/>
                <div className="card-footer">
                    <Button size={"xs"} color={"gray"} variant={"outline"} onClick={() => setEditProcessorOpened(true)}>
                        <Edit/>
                    </Button>
                </div>
            </ProcessorCard>

            <Handle type="target" position={Position.Top} id="top"/>
            <Handle type="source" position={Position.Bottom} id="bottom"/>
            {
                editProcessorOpened &&
                <SmartTriggerProcessorConfigurationModal
                    isOpened={editProcessorOpened}
                    onClose={() => setEditProcessorOpened(false)}
                    action={{
                        type: 'update',
                        processorId: props.id
                    }}

                />
            }
        </>
    )
        ;
}
